export default "__VITE_ASSET__6f9faa16__"